<template>
  <div class="compare-items">
        <div 
            class="compare-item" 
        >
            <div 
                class="compare-item__head compare-item__head_left"  
            >
                <div style="margin-left:-7px" v-if="allowDifferent && compare"> 
                    <el-radio-group
                        v-model="isDifferents"
                        class="compare-radio"
                    >
                        <el-radio :label="false">All</el-radio>
                        <el-radio :label="true">Differents</el-radio>
                    </el-radio-group> 
                </div> 
            </div>
            <div class="compare-item__body compare-item__body_border">
                <!-- MAIN PARAMETERS START  -->
                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title">Main parameters</li>
                    <li>Handymen efficiency:</li>
                    <li>Travel time:</li>
                    <li>Inactive time:</li>
                    <li>First DoS:</li>
                    <li>Final DoS:</li> 
                    <li>Booked hours / paid hours:</li>
                    <li>Transfer:</li>
                </ul>
                <!-- MAIN PARAMETERS END  -->

                <!-- INPUT PARAMETERS START  -->
                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title">Orders generation</li>
                    <li>Orders quantity:</li>
                    <li>Masters quantity:</li>
                    <li>Working time from/till:</li> 
                    <li>Numnber of days:</li>
                    <li>Order duration from/till:</li> 
                    <li>Schedule from/till:</li>
                    <li>Canceled requests by clients:</li>
                    <li>Percent of clients agree to transfer request:</li>
                    <li>Handymen absent daily:</li>
                     
                </ul>
                <!-- INPUT PARAMETERS END  -->
  
                <!-- SECTORS START  -->
                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title">Central</li>  
                    <li>Coefficient</li>
                    <li>Percent of masters</li>
                    <li>Percent of orders</li>
                    <li>Start time</li>
                    <li>End time</li>
                </ul>

                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title">East</li>  
                    <li>Coefficient</li>
                    <li>Percent of masters</li>
                    <li>Percent of orders</li>
                    <li>Start time</li>
                    <li>End time</li>
                </ul>

                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title">Donaustadt</li>  
                    <li>Coefficient</li>
                    <li>Percent of masters</li>
                    <li>Percent of orders</li>
                    <li>Start time</li>
                    <li>End time</li>
                </ul>

                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title">North</li>  
                    <li>Coefficient</li>
                    <li>Percent of masters</li>
                    <li>Percent of orders</li>
                    <li>Start time</li>
                    <li>End time</li>
                </ul>

                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title">South</li>  
                    <li>Coefficient</li>
                    <li>Percent of masters</li>
                    <li>Percent of orders</li>
                    <li>Start time</li>
                    <li>End time</li>
                </ul>
                <!-- SECTORS END  -->
            </div>
        </div>  
 
        <div 
            class="compare-item" 
            v-for="item in data" 
            :key="item.id"
        > 
            <div class="compare-item__head">
                <main-actions 
                    class="compare-item__actions"
                    :isCompared="item.simulation.comparing"
                    :isFavs="item.simulation.favorites"
                    :id="item.simulation.id"
                />  

                <div class="compare-item__title">
                    <router-link class="compare-item__link" :to="{name: `Results`, params: {
                            id: item.simulation.id
                        }, query: {
                            name: item.simulation.db_schema
                        }}"> 
                        Simulation #{{item.simulation.id}}
                    </router-link>
                    <span class="compare-item__title_date"> {{dateFormat(item.simulation.created_at)}} </span>
                </div>
            </div>
            <div class="compare-item__body">
                <!-- MAIN PARAMETERS START  -->
                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title"></li> 
                    <li 
                        :ref="`simulation_indicator_1_${item.simulation.id}`"
                        :class="`simulation_indicator_1 simulation_indicator_${item.simulation.indicators.sold_hours}`"
                        :data-id="item.simulation.indicators.sold_hours"
                    >
                        {{item.simulation.indicators.sold_hours || 0}}%
                    </li>

                    <li 
                        :ref="`simulation_indicator_2_${item.simulation.id}`"
                        :class="`simulation_indicator_2 simulation_indicator_${item.simulation.indicators.in_the_way}`"
                        :data-id="item.simulation.indicators.in_the_way"
                    >
                        {{item.simulation.indicators.in_the_way || 0}}%
                    </li>

                    <li 
                        :ref="`simulation_indicator_3_${item.simulation.id}`"
                        :class="`simulation_indicator_3 simulation_indicator_${item.simulation.indicators.inactive}`"
                        :data-id="item.simulation.indicators.inactive"
                    >
                        {{item.simulation.indicators.inactive || 0}}%
                    </li>

                    <li 
                        :ref="`simulation_indicator_4_${item.simulation.id}`"
                        :class="`simulation_indicator_4 simulation_indicator_${item.simulation.indicators.first_denied}`"
                        :data-id="item.simulation.indicators.first_denied"
                    >
                        {{item.simulation.indicators.first_denied || 0}}%
                    </li>
                    <li
                        :ref="`simulation_indicator_5_${item.simulation.id}`"
                        :class="`simulation_indicator_5 simulation_indicator_${item.simulation.indicators.final_denied}`"
                        :data-id="item.simulation.indicators.final_denied"
                    >
                        {{item.simulation.indicators.final_denied || 0}}%
                    </li> 

                    <li
                        :ref="`simulation_indicator_6_${item.simulation.id}`"
                        :class="`simulation_indicator_6 simulation_indicator_${item.simulation.indicators.requested_hours}`"
                        :data-id="item.simulation.indicators.requested_hours"
                    >
                        {{item.simulation.indicators.requested_hours}}/{{item.simulation.indicators.completed_hours}} h
                    </li>
                    <li 
                        :ref="`simulation_indicator_7_${item.simulation.id}`"
                        :class="`simulation_indicator_7 simulation_indicator_${item.simulation.indicators.carry_over}`"
                        :data-id="item.simulation.indicators.carry_over"
                    >
                        {{item.simulation.indicators.carry_over}}%
                    </li>
                </ul>
                <!-- MAIN PARAMETERS END  -->

                <!-- INPUT PARAMETERS START  -->
                <ul class="compare-item__ul">   
                    <li class="compare-item__ul_title"></li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('orders_quantity')}"> 
                        {{item.simulation.orders_quantity}} 
                    </li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_quantity')}"> 
                        {{item.simulation.masters_quantity}} 
                    </li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('simulation_from') && isTheSame('simulation_to')}"> {{dateFormat(item.simulation.simulation_from, 'l')}} - {{dateFormat(item.simulation.simulation_to, 'l')}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('days')}"> {{getNumberOfDays(item.simulation.simulation_from, item.simulation.simulation_to)}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('duration_from') && isTheSame('duration_to')}">{{numberToHour(item.simulation.duration_from)}}/{{numberToHour(item.simulation.duration_to)}}</li>
                    <!-- <li>2h/30%</li>  -->
                    <li :class="{'compare-item__ul_opacity': isTheSame('schedule_from') && isTheSame('schedule_to')}">{{item.simulation.schedule_from}}-{{item.simulation.schedule_to}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('canceled')}">{{item.simulation.request.orders.canceled || 0}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('input_carry_over')}">{{item.simulation.request.orders.carry_over || 0}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('not_go_work')}">{{item.simulation.request.masters.working_timesheet.not_go_work || 0}}%</li>
                </ul>
                <!-- INPUT PARAMETERS END  -->

                <!-- SECTORS START  -->
                <ul class="compare-item__ul">    
                    <li class="compare-item__ul_title"></li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_a_coefficient')}">{{item.simulation.orders.areas.area_a.coefficient || 1}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_a_percent')}">{{item.simulation.masters.areas.area_a.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('orders_area_a_percent')}">{{item.simulation.orders.areas.area_a.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_a_start_time')}">
                        <span v-if="item.simulation.orders.areas.area_a.time.from != undefined">
                            {{item.simulation.orders.areas.area_a.time.from}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_from}}
                        </span>
                    </li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_a_end_time')}">
                        <span v-if="item.simulation.orders.areas.area_a.time.to != undefined">
                            {{item.simulation.orders.areas.area_a.time.to}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_to}}
                        </span>
                    </li>
                </ul>

                <ul class="compare-item__ul">    
                    <li class="compare-item__ul_title"></li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_b_coefficient')}">{{item.simulation.orders.areas.area_b.coefficient || 1}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_b_percent')}">{{item.simulation.masters.areas.area_b.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('orders_area_b_percent')}">{{item.simulation.orders.areas.area_b.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_b_start_time')}">
                        <span v-if="item.simulation.orders.areas.area_b.time.from != undefined">
                            {{item.simulation.orders.areas.area_b.time.from}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_from}}
                        </span>
                    </li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_b_end_time')}">
                        <span v-if="item.simulation.orders.areas.area_b.time.to != undefined">
                            {{item.simulation.orders.areas.area_b.time.to}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_to}}
                        </span>
                    </li>
                </ul>

                <ul class="compare-item__ul">    
                    <li class="compare-item__ul_title"></li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_c_coefficient')}">{{item.simulation.orders.areas.area_c.coefficient || 1}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_c_percent')}">{{item.simulation.masters.areas.area_c.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('orders_area_c_percent')}">{{item.simulation.orders.areas.area_c.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_c_start_time')}">
                        <span v-if="item.simulation.orders.areas.area_c.time.from != undefined">
                            {{item.simulation.orders.areas.area_c.time.from}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_from}}
                        </span>
                    </li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_c_end_time')}">
                        <span v-if="item.simulation.orders.areas.area_c.time.to != undefined">
                            {{item.simulation.orders.areas.area_c.time.to}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_to}}
                        </span>
                    </li>
                </ul>

                <ul class="compare-item__ul">    
                    <li class="compare-item__ul_title"></li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_d_coefficient')}">{{item.simulation.orders.areas.area_d.coefficient || 1}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_d_percent')}">{{item.simulation.masters.areas.area_d.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('orders_area_d_percent')}">{{item.simulation.orders.areas.area_d.percent}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_d_start_time')}">
                        <span v-if="item.simulation.orders.areas.area_d.time.from != undefined">
                            {{item.simulation.orders.areas.area_d.time.from}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_from}}
                        </span>
                    </li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_d_end_time')}">
                        <span v-if="item.simulation.orders.areas.area_d.time.to != undefined">
                            {{item.simulation.orders.areas.area_d.time.to}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_to}}
                        </span>
                    </li>
                </ul>

                <ul class="compare-item__ul">    
                    <li class="compare-item__ul_title"></li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_e_coefficient')}">{{item.simulation.orders.areas.area_e.coefficient || 1}}</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_e_percent')}">{{item.simulation.masters.areas.area_e.percent || 0}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('orders_area_e_percent')}">{{item.simulation.orders.areas.area_e.percent || 0}}%</li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_e_start_time')}">
                        <span v-if="item.simulation.orders.areas.area_e.time.from != undefined">
                            {{item.simulation.orders.areas.area_e.time.from}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_from}}
                        </span>
                    </li>
                    <li :class="{'compare-item__ul_opacity': isTheSame('masters_area_e_end_time')}">
                        <span v-if="item.simulation.orders.areas.area_e.time.to != undefined">
                            {{item.simulation.orders.areas.area_e.time.to}}
                        </span>
                        <span v-else>
                            {{item.simulation.schedule_to}}
                        </span>
                    </li>
                </ul>  
                <!-- SECTORS END -->

                <main-comments  
                    v-if="item.simulation.comments"
                    :comments="item.simulation.comments"
                    :id="item.simulation.id" 
                />
            </div> 
        </div>  
    </div>
</template>

<script>
import Vue from 'vue';
import dateMixin from '@/mixins/dateMixin';
import {mapActions} from 'vuex';

export default {
    props: {
        comments: {
            default: false
        },
        compare: {
            default: false
        },
        data: {
            required: true
        },
        allowDifferent: {
            required: false
        },
        matches: {
            required: false
        }
    },
    name: 'main-list',
    mixins: [dateMixin],
    data() {
        return { 
            isDifferents: false
        }
    },
    methods: { 
        getStats() {
            if (!this.compare) { // active only for compare page
                return;
            } 
            
            const values = Object.values(this.$refs);
            const indicators = {
                indicator_1: {
                    data: [],
                    biggestOne: 0
                },
                indicator_2: {
                    data: [],
                    biggestOne: 0
                },
                indicator_3: {
                    data: [],
                    biggestOne: 0
                },
                indicator_4: {
                    data: [],
                    biggestOne: 0
                },
                indicator_5: {
                    data: [],
                    biggestOne: 0
                },
                indicator_6: {
                    data: [],
                    biggestOne: 0
                },
                indicator_7: {
                    data: [],
                    biggestOne: 0
                }
            };  
 
            values.forEach(element => { 
                if(element.length == 0) {
                    return;
                }    
                
                if(element[0].classList.contains('simulation_indicator_1')) {
                    this.appendMatches(indicators.indicator_1, element);
                }  
                else if (element[0].classList.contains('simulation_indicator_2')) { 
                    this.appendMatches(indicators.indicator_2, element); 
                }   
                else if (element[0].classList.contains('simulation_indicator_3')) { 
                    this.appendMatches(indicators.indicator_3, element); 
                }    
                else if (element[0].classList.contains('simulation_indicator_4')) { 
                    this.appendMatches(indicators.indicator_4, element); 
                } 
                else if (element[0].classList.contains('simulation_indicator_5')) { 
                    this.appendMatches(indicators.indicator_5, element);
                }  
                else if (element[0].classList.contains('simulation_indicator_6')) {  
                    this.appendMatches(indicators.indicator_6, element);
                } 
                else if (element[0].classList.contains('simulation_indicator_7')) {  
                    this.appendMatches(indicators.indicator_7, element);
                }    
            });     
            
            for (const key in indicators) { 
                const indicator = indicators[key];
              
                this.styleIndicator(indicator); 
            } 
        },
        styleIndicator({data, biggestOne}) {  
            data.forEach(element => { 
                if(element.length  == 0) {
                    return;
                }

                const el = element[0];
                const data = el.getAttribute('data-id');

                if(biggestOne == data) {
                    el.classList.remove('compare-item__li_less');
                    el.classList.add('compare-item__li_more');
                }
                else {
                    el.classList.remove('compare-item__li_more');
                    el.classList.add('compare-item__li_less');
                }
            });
        },
        appendMatches(indicator, element) {
            indicator.data.push(element);

            const el = element[0];
            const data = parseFloat(el.getAttribute('data-id'));
  
            if(data > indicator.biggestOne) {
                indicator.biggestOne = data;
            } 
        },
        isTheSame(key) { 
            if(this.matches == undefined) {
                return false;
            }

            if(this.matches.indexOf(key) != -1 || this.isDifferents == false) {
                return false;
            } 

            return true;
        }
    }, 
    mounted() {  
        this.getStats();  
    },
    updated() {
        this.getStats();    
    } 
} 
</script>

<style>
.compare-item__ul_opacity {
    opacity: 0.3;
}
</style>